import style from './index.module.scss';
import {Button, message, Modal} from 'antd';
import {errorMessage, isTrue} from 'Utils/common';
import useModalHandler from 'Utils/Hooks/useModalHandler';
import AddTaskModal from '../AddTaskModal';
import {
    changeTaskStatus,
    deleteTask,
    executeTask,
    Status,
    TaskListItem,
} from '../../../../../service';

interface OperationsProps {
    record: TaskListItem; //当前课程列表
    updateData: () => void; //刷新列表
}

export default function Operations({record, updateData}: OperationsProps) {
    const editModal = useModalHandler({
        component: AddTaskModal,
    });

    const handleChange = async (status: string) => {
        try {
            await changeTaskStatus(record.id, status);
            updateData();
            message.success(status === Status.Open ? '启用成功' : '停用成功');
        } catch (e) {
            message.error(errorMessage(e));
        }
    };

    //删除任务
    function handleDelete(id: string) {
        Modal.confirm({
            title: `删除调度任务？`,
            content:
                '删除调度任务后不可恢复，且如果当前调度任务有被调度计划引用，那么删除任务后，调度计划任务将不再执行。确定删除？',
            onOk: async () => {
                try {
                    await deleteTask(id);
                    message.success('调度任务删除成功');
                    updateData();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            },
        });
    }

    function handleExecute(id: string) {
        Modal.confirm({
            title: `任务执行后将无法终止或撤销执行，确定执行任务？`,
            onOk: async () => {
                try {
                    await executeTask(id);
                    message.success('执行成功');
                    updateData();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            },
        });
    }

    return (
        <div className={style.tools}>
            <div className={style.container}>
                {isTrue(record.status) && (
                    <Button
                        type="link"
                        className={style.btn}
                        onClick={() => handleChange('0')}>
                        停用
                    </Button>
                )}
                {!isTrue(record.status) && (
                    <Button
                        type="link"
                        className={style.btn}
                        onClick={() => handleChange('1')}>
                        启用
                    </Button>
                )}
                <Button
                    type="link"
                    className={style.btn}
                    onClick={() => handleExecute(record.id)}>
                    执行
                </Button>
                {!isTrue(record.status) && (
                    <Button
                        type="link"
                        className={style.btn}
                        onClick={() => {
                            editModal.open({
                                flag: 'edit',
                                initValue: record,
                                updateData: () => {
                                    editModal.close();
                                    updateData();
                                },
                            });
                        }}>
                        编辑
                    </Button>
                )}
                {!isTrue(record.status) && (
                    <Button
                        type="link"
                        className={style.btn}
                        onClick={() => handleDelete(record.id)}>
                        删除
                    </Button>
                )}
            </div>

            {editModal.render()}
        </div>
    );
}
